import { ChangeEvent, ComponentPropsWithoutRef, ReactNode } from 'react';
import { RadioGroupBlockWrapper, RadioGroupTitle, RadioGroupWrapper } from './styles';
import { RadioField } from './RadioField';
import { Box } from '@/components/Box/Box';
import { InputError } from '../InputError/InputError';

export type RadioOptionType = {
  value: string;
  label: string;
};

export type RadioGroupType = {
  label: ReactNode;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  options: ReadonlyArray<RadioOptionType>;
  disabled?: boolean;
  hasErrorComponent?: boolean;
  error?: string;
  apiError?: string;
  gridMode?: boolean;
} & ComponentPropsWithoutRef<'input'>;

export const RadioGroup = ({
  value,
  label,
  options,
  disabled = false,
  onChange,
  error,
  apiError,
  hasErrorComponent = false,
  gridMode,
  ...rest
}: RadioGroupType) => {
  return (
    <RadioGroupWrapper>
      <RadioGroupTitle>{label}</RadioGroupTitle>
      <RadioGroupBlockWrapper gridMode={gridMode}>
        {options.map((option, index) => {
          const key = `${index}_${option.label}`;

          return (
            <RadioField
              key={key}
              label={option.label}
              onChange={onChange}
              value={option?.value}
              checked={value === option.value}
              disabled={disabled}
              {...rest}
            />
          );
        })}
      </RadioGroupBlockWrapper>
      {hasErrorComponent && (
        <Box display='flex'>
          <InputError error={error} apiError={apiError} />
        </Box>
      )}
    </RadioGroupWrapper>
  );
};
